import { dayConflictHighlightGetter, resourceConflictHighlightGetter } from '@lp/features/Scheduler/utils';
import { OMSShiftOptionType } from './types';
import { OMSShiftType } from '@/api/apis/resources/schedule';
import { getNameValuesFromEnumNames } from '@/utils/helpers';
import { NameByValue } from '@/types';

export const singleOMSShiftTypes = [OMSShiftType.OnCall, OMSShiftType.AdminDay, OMSShiftType.NoCall];

export const slotSelectableOMSShiftTypes = [OMSShiftType.OnCall, OMSShiftType.AdminDay];

export const omsShiftOptionToTypeMap: Record<OMSShiftOptionType, OMSShiftType> = {
  [OMSShiftOptionType.OnCall]: OMSShiftType.OnCall,
  [OMSShiftOptionType.OnCallVoluntary]: OMSShiftType.OnCall,
  [OMSShiftOptionType.AdminDay]: OMSShiftType.AdminDay,
  [OMSShiftOptionType.NoCall]: OMSShiftType.NoCall,
  [OMSShiftOptionType.SickLeave]: OMSShiftType.SickLeave,
  [OMSShiftOptionType.Unavailable]: OMSShiftType.Unavailable,
  [OMSShiftOptionType.Vacation]: OMSShiftType.Vacation,
};

export const omsShiftTypeNames: Record<OMSShiftType, string> = {
  [OMSShiftType.OnCall]: 'On Call',
  [OMSShiftType.AdminDay]: 'Admin Day',
  [OMSShiftType.NoCall]: 'No Call',
  [OMSShiftType.SickLeave]: 'Sick Leave',
  [OMSShiftType.Unavailable]: 'Unavailable',
  [OMSShiftType.Vacation]: 'Vacation',
};

export const omsShiftOptionTypeNames: Record<OMSShiftOptionType, string> = {
  ...omsShiftTypeNames,
  [OMSShiftOptionType.OnCallVoluntary]: 'On Call (Voluntary)',
};

export const omsShiftOptionDropdownItems = [
  OMSShiftOptionType.OnCall,
  OMSShiftOptionType.OnCallVoluntary,
  OMSShiftOptionType.AdminDay,
  OMSShiftOptionType.NoCall,
  OMSShiftOptionType.SickLeave,
  OMSShiftOptionType.Unavailable,
];

export const omsShiftTotalsTypeNames: Record<OMSShiftOptionType, string> = {
  ...omsShiftOptionTypeNames,
};

export const omsShiftTotalsTypes = [
  OMSShiftOptionType.OnCall,
  OMSShiftOptionType.OnCallVoluntary,
  OMSShiftOptionType.AdminDay,
  OMSShiftOptionType.NoCall,
  OMSShiftOptionType.SickLeave,
  OMSShiftOptionType.Unavailable,
];

export const OMS_SHIFT_TYPE_SELECT_LIST = getNameValuesFromEnumNames(omsShiftTypeNames);

export const OMS_SHIFT_OPTION_TYPE_SELECT_LIST = getNameValuesFromEnumNames(omsShiftOptionTypeNames);

export const OMS_SHIFT_OPTION_DROPDOWN_LIST: NameByValue<OMSShiftOptionType>[] = omsShiftOptionDropdownItems.map(
  (so) => ({
    value: so,
    name: omsShiftOptionTypeNames[so],
  }),
);

export const OMS_SLOT_OPTION_DROPDOWN_LIST = [
  {
    slotIndex: 1,
    label: '1st Shift',
    timeRange: '09:00-21:00',
  },
  {
    slotIndex: 2,
    label: '2nd Shift',
    timeRange: '21:00-09:00',
  },
];

export const OMS_ADMIN_DAY_COMBINE_INFO =
  'Admin Day can be combined with On‑Call only when scheduled in Slot 1 on the same day.';

export const omsConflictsDrawerData = [
  { label: 'BY USER', accessorKey: 'resourcesMessagesList', transformerFn: resourceConflictHighlightGetter } as const,
  {
    label: 'BY DAY',
    accessorKey: 'dayMessagesList',
    ignoreDay: true,
    transformerFn: dayConflictHighlightGetter,
  } as const,
];
